var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoodBefore = function SvgMoodBefore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.03 0a8.03 8.03 0 1 0 .36 16.06 1 1 0 0 0 1-1v-.88h-.88a1 1 0 0 0-.48-.12 6.03 6.03 0 1 1 0-12.06 1 1 0 0 0 .48-.12h.88V1A1 1 0 0 0 11.2.02a1 1 0 0 0-.18-.02Zm-.64 3.64v1.75h2V3.64h-2Zm0 7.02v1.76h2v-1.76h-2Zm0-3.51v1.76h2V7.15h-2Z",
    clipRule: "evenodd"
  })));
};
export default SvgMoodBefore;